import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { getGeneratedMenu } from '../../actions/menus';
import DishesList from './DishesList';
import DishDetails from './DishDetails';
import ChangePage from './ChangePage';
import styles from './DishesPage.module.css';

const DishesPage = (props) => {
  const { 
    menus,
    getGeneratedMenu,
    onSuccess,
  } = props;

  // const [showDish, setShowDish] = useState(107);
  // const [showChangePage, setShowChangePage] = useState({ day: 1, meal: 'breakfast' });
  const [showDish, setShowDish] = useState(false);
  const [showChangePage, setShowChangePage] = useState(null);

  useEffect(() => {
    getGeneratedMenu();
  }, []);

  const onBackHandler = () => {
    setShowDish(false);
  };

  const onChangeDishHandler = () => {
    setShowChangePage({ day: showDish.day, meal: showDish.meal_name });
  };

  // console.log('===menus', menus);

  // !!!ChangePage must be before DishDetails (we can show ChangePage in DishDetails)
  if (showChangePage) {
    return (
      <ChangePage 
        day={showChangePage.day} 
        meal={showChangePage.meal}
        onBack={() => setShowChangePage(null)}
        onChange={() => {
          setShowDish(false);
          setShowChangePage(null);
        }}
      />
    );
  }

  if (showDish) {
    return (
      <DishDetails 
        dishId={showDish.id}
        onBack={onBackHandler}
      >
        <button 
          className={cn(styles.transparentButton, styles.mobileHidden)}
          onClick={onBackHandler}
        >
          Back
        </button>
        <button className={styles.greenButton} onClick={onChangeDishHandler}>
          Change Page
        </button>
      </DishDetails>
    );
  }

  return (
    <DishesList 
      menus={menus}
      onShowDish={setShowDish}
      onShowChangePage={setShowChangePage}
      onSuccess={onSuccess}
    />
  );
};

const mapStateToProps = (state) => ({
  menus: state.menus.menusData,
});

const mapDispatchToProps = {
  getGeneratedMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(DishesPage);